import React, { useState } from "react";
import {
  Button,
  Dialog,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Input,
  Checkbox,
  Switch,
} from "@material-tailwind/react";
import { useHttp } from "@/hooks/useFetch";
import { useGlobalData } from "../Layout/GlobalContext";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { useUserStore } from "@/store/user";
import { ForgotPasswordDialog } from "./ForgotPasswordDialog";
import { useI18n } from "@/i18n";

export function LoginDialog({
  open,
  handleClose,
}: {
  open: boolean;
  handleClose: () => void;
}) {
  const { $t } = useI18n();
  const { Http } = useHttp();
  const { setLoginModal, setRegisterModal, login, alert } = useGlobalData();

  const [phone, setphone] = useState("");
  const [password, setPassword] = useState("");
  const [submit, setSubmit] = useState(false);
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const { authCode } = useUserStore();

  const handleCloseClick = () => {
    handleClose && handleClose();
  };

  const handleLogin = async () => {
    setSubmit(true);
    if (!phone || !password) return;
    await login(phone, password, authCode);

    alert({
      color: "green",
      message: $t("登录成功"),
    });

    setLoginModal(false);
  };

  return (
    <>
      <Dialog
        size="xs"
        open={open}
        handler={() => setLoginModal(true)}
        className="bg-transparent shadow-none"
      >
        <Card className="mx-auto w-full max-w-[24rem]">
          <CardBody className="flex flex-col gap-4">
            <XCircleIcon
              className="absolute w-7 right-5 top-5 cursor-pointer"
              onClick={handleCloseClick}
            />
            <Typography variant="h4" color="blue-gray">
              {$t("登录")}
            </Typography>
            <Typography
              className="mb-3 font-normal"
              variant="paragraph"
              color="gray"
            >
              {$t("请输入你的手机号和密码进行登录")}
            </Typography>
            <Typography className="-mb-2" variant="h6">
              {$t("手机号")}
            </Typography>
            <Input
              error={submit && !phone}
              onChange={({ target }) => setphone(target.value)}
              crossOrigin=""
              label={$t("Phone")}
              autoComplete="off"
              size="lg"
            />
            <Typography className="-mb-2" variant="h6">
              {$t("密码")}
            </Typography>
            <Input
              error={submit && !password}
              type="password"
              autoComplete="new-password"
              onChange={({ target }) => setPassword(target.value)}
              crossOrigin=""
              label={$t("Password")}
              size="lg"
            />
            <div className="ml-1 flex justify-between items-center">
              <Switch crossOrigin="" label={$t("记住密码")} />
              <Typography
                as="a"
                variant="small"
                color="black"
                className="cursor-pointer hover:underline"
                onClick={() => setForgotPasswordOpen(true)}
              >
                {$t("忘记密码？")}
              </Typography>
            </div>
          </CardBody>
          <CardFooter className="pt-0">
            <Button variant="gradient" onClick={() => handleLogin()} fullWidth>
              {$t("登录")}
            </Button>
            <Typography variant="small" className="mt-4 flex justify-center">
              {$t("还没有账号？")}
              <Typography
                as="a"
                variant="small"
                color="blue-gray"
                className="ml-1 font-bold"
                onClick={() => {
                  handleCloseClick();
                  setRegisterModal(true);
                }}
              >
                {$t("注册")}
              </Typography>
            </Typography>
          </CardFooter>
        </Card>
      </Dialog>

      {/* 忘记密码弹框 */}
      <ForgotPasswordDialog
        open={forgotPasswordOpen}
        onClose={() => setForgotPasswordOpen(false)}
      />
    </>
  );
}

export const NoLogin: React.FC<{
  login?: () => void;
}> = ({ login }) => {
  const { $t } = useI18n();
  const Global = useGlobalData();
  return (
    <div className="flex flex-col justify-center items-center">
      <img
        className="w-80 h-52"
        src="https://cool-jiaojq.oss-cn-beijing.aliyuncs.com/app%2Fbase%2F8f0b95d1ec874a3187067f4cdd64bd40_nologin.png"
        alt=""
      />
      <Button
        onClick={() => {
          Global.handleRegister({
            onSuccess() {
              login && login();
            },
          });
        }}
        className="mt-5"
      >
        {$t("登录查看")}
      </Button>
    </div>
  );
};
